function hexToRgb(color: string): string {
  color = color.replace(/^#/, '');
  let r, g, b;

  if (color.length === 3) {
    r = parseInt(color[0] + color[0], 16);
    g = parseInt(color[1] + color[1], 16);
    b = parseInt(color[2] + color[2], 16);
  } else if (color.length === 6) {
    r = parseInt(color.substring(0, 2), 16);
    g = parseInt(color.substring(2, 4), 16);
    b = parseInt(color.substring(4, 6), 16);
  } else {
    throw new Error('Invalid hex color format');
  }

  return `${r}, ${g}, ${b}`;
}

export default hexToRgb;
